import { WindowWrapper } from 'login-utils/globalWrappers';
import baseRequest from './baseRequest';

export interface StateTrackingParams {
  appName: string;
  pageName: string;
  url: string;
  version: string;
}

export function logEvent(eventName: string, eventBody: {}) {
  const appName = WindowWrapper.APP_NAME;

  const body = {
    appName,
    version: WindowWrapper.APP_VERSION,
    name: `frontend.${appName}.${eventName}`,
    meta: eventBody,
  };

  return baseRequest.post(`/api/frontend-tracking/events`, body);
}
